import Vue from 'vue'
import Router from 'vue-router'
// import store from './store';

import Home from './views/Home.vue'
import Landing from './views/Landing.vue'
import Closed from './views/Closed.vue'
import Penilaian from './views/Penilaian.vue'
import PenilaianFasilitas from './views/PenilaianFasilitas.vue'
import PenilaianDetail from './views/PenilaianDetail.vue'
import PenilaianDetailFasilitas from './views/PenilaianDetailFasilitas.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing
    },
    {
      path: '/home/:id',
      name: 'home',
      component: Home
    },
    {
      path: '/home/:outlet/:id/employees',
      name: 'penilaian',
      component: Penilaian
    },
    {
      path: '/home/:outlet/:id/facilities',
      name: 'penilaianfasilitas',
      component: PenilaianFasilitas
    },
    {
      path: '/home/:outlet/:id/employees/:npp',
      name: 'penilaiandetail',
      component: PenilaianDetail
    },
    {
      path: '/home/:outlet/:id/facilities/:fid',
      name: 'penilaiandetailfasilitas',
      component: PenilaianDetailFasilitas
    },
    {
      path: '/closed-operational',
      name: 'closedOperational',
      component: Closed
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})

const time = new Date().getHours()
const day = new Date().getDay()

router.beforeEach((to, from, next) => {
    // ignore operational hours rule on landing
  if (to.name === "landing") {
    next()
    return
  }

  // Senin - Jumat 7 s/d 16
  if (to.path !== "/closed-operational" && day <= 5) {
    const openOperation = 8
    const closedOperation = 15
    if (time >= openOperation && time <= closedOperation) {
      next()
    } else {
      router.push({ name: 'closedOperational' })
    }
  }

  // Sabtu 7 s/d 15
  // if (to.path !== "/closed-operational" && day == 6) {
  //   const openOperation = 7
  //   const closedOperation = 15
  //   if (time > openOperation && time < closedOperation) {
  //     next()
  //   } else {
  //     router.push({ name: 'closedOperational' })
  //   }
  // }

  // Sabtu & Minggu libur
  if (to.path !== "/closed-operational" && day == 7 || to.path !== "/closed-operational" && day == 6) {
    router.push({ name: 'closedOperational' })
  }
  next()

})

export default router